import type {DateObj, DateTimeObj} from './types';

import {not} from '../conditionalUtils';
import {isDefined} from '../typecheck';

export const SLASH = '/';

export const DASH = '-';

export const COLON = ':';

export const PLUS = '+';

export const MINUS = '-';

export const DOT = '.';

export const Z = 'Z';

export const DEFAULT_DATE_STRING = '3000-01-01';

export const DEFAULT_DATE_OBJ: DateObj = {
  _type: 'date',
  day: 1,
  month: 1,
  year: 3000,
};

export const DATE_FORMAT_DEFAULT = 'YYYY-MM-DD';

export const DATE_FORMAT_SHORT = 'ddd, MMM DD';

export const DATE_FORMAT_L = 'L';

export const DEFAULT_DATETIME_OBJ: DateTimeObj = {
  _type: 'datetime',
  day: 1,
  hour: 0,
  microsecond: 0,
  minute: 0,
  month: 1,
  second: 0,
  utcoffset: 0,
  year: 3000,
};

const commonValidator = (value: any) =>
  isDefined(value) && not(isNaN(value)) && value !== '';

export const dayValidator = day => commonValidator(day) && day > 0 && day < 32;

export const monthValidator = month =>
  commonValidator(month) && month > 0 && month < 13;

export const yearValidator = year =>
  commonValidator(year) && year >= 0 && year <= 9999;
